import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ThemeInfoModel } from '../Models/theme.model';
import { AuthService } from '../auth.service'
import { DashboardService } from 'app/dashboard/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';

@Component({
  selector: 'app-customtheme',
  templateUrl: './customtheme.component.html',
  styleUrls: ['./customtheme.component.scss']
})
export class CustomthemeComponent implements OnInit {
 

  constructor(public dialog: MatDialog, public authservice: AuthService, 
     public dashboardService: DashboardService, public translate: TranslateService,
    public langservice: LanguageService) {
      translate.addLangs(['en', 'fr', 'hi']);
      if (this.langservice.setlang) {
        translate.setDefaultLang(this.langservice.setlang);
      }
      else {
        translate.setDefaultLang('en');
      }
  }

  ngOnInit(): void { 
   console.log( this.authservice.selectedTheme);

   }

 onthemesChange(){
     if(this.authservice.checkThemeStatus === 1){
       this.authservice.selectedTheme = 'Default';
       this.authservice.setdefailthem();
      }
      else{
        this.authservice.setcusthemeforme();
        this.authservice.selectedTheme = 'Custom'
       }
    }
    



  closedialog() {
    this.dialog.closeAll();
   }

  

}
